import ButtonBuyTickets from "../ButtonBuyTickets/ButtonBuyTickets";

const NavigationItems = () => {
  return (
    <nav className="d-none d-md-flex gap-4 ps-4 font-pnr text-white">
      {/* <a href='#event-agenda'>Agenda</a> */}
      <a href="#events-slider-section">Tickets</a>
      <a href="#maldive-events-cards">Events</a>
      {/* <a href='#event-faq'>FAQ</a> */}

      <ButtonBuyTickets />
    </nav>
  );
};
export default NavigationItems;
